import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/rubric-bank',
        name: 'rubric-bank-index',
        component: () => import('@/pages/rubric-banks/RubricBankIndex.vue'),
        meta: {
            title: 'Rubric Bank',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'rubric banks' },
        },
    },

    {
        path: '/rubric-bank/archive',
        name: 'rubric-bank-index-archive',
        component: () => import('@/pages/rubric-banks/RubricBankIndex.vue'),
        meta: {
            title: 'Archived Rubric Bank',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('archive a rubric bank'),
        },
    },
    {
        path: '/rubric-bank/create',
        name: 'rubric-bank-create',
        component: () => import('@/pages/rubric-banks/RubricBankCreate.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'create', subject: 'rubric bank' },
        },
    },
    {
        path: '/rubric-bank/:rubricBankId',
        name: 'rubric-bank-view',
        component: () => import('@/pages/rubric-banks/RubricBankView.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'rubric bank' },
        },
        props: true,
    },
    {
        path: '/rubric-bank/:rubricBankId/edit',
        name: 'rubric-bank-edit',
        component: () => import('@/pages/rubric-banks/RubricBankEdit.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'edit', subject: 'rubric bank' },
        },
        props: true,
    },
];
